var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { INSIDER_CART_CHANGED, silentCartUpdate, } from './mod-cart-event-bus.js';
// Guard distinctUntilChanged — descarta evento se o token não mudou.
// O cart.token é fixo por sessão no Shopify, então, na prática, só persiste uma vez.
let _lastPersistedToken = null;
function persistCartId(token) {
    return __awaiter(this, void 0, void 0, function* () {
        if (token === _lastPersistedToken)
            return;
        // Seta antes do await para evitar race condition:
        // se um segundo evento chegar antes do fetch completar, cai no guard acima.
        _lastPersistedToken = token;
        console.debug(`[cart-attribute-tracker] persist cartId: ${token}`);
        try {
            yield silentCartUpdate({ attributes: { _cartId: token } });
        }
        catch (err) {
            // Reverte em caso de erro para permitir nova tentativa
            _lastPersistedToken = null;
            console.warn('[cart-attribute-tracker] Failed to persist cartId:', err);
        }
    });
}
document.addEventListener(INSIDER_CART_CHANGED, (e) => {
    const { cart } = e.detail;
    if (cart === null || cart === void 0 ? void 0 : cart.token)
        persistCartId(cart.token);
});
